import { render } from "./PreavisFormCreateEdit.vue?vue&type=template&id=034cc94a&scoped=true&ts=true"
import script from "./PreavisFormCreateEdit.vue?vue&type=script&lang=ts"
export * from "./PreavisFormCreateEdit.vue?vue&type=script&lang=ts"

import "./PreavisFormCreateEdit.vue?vue&type=style&index=0&id=034cc94a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034cc94a"]])

export default __exports__